
























import {
  Component, Emit, Prop, Vue,
} from 'vue-property-decorator';

import TransactionParticipantForm, { TransactionParticipantDto } from '@/components/TransactionParticipantForm.vue';

@Component({
  components: { TransactionParticipantForm },
  inheritAttrs: false,
})
export default class TransactionParticipantModal extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  readonly title!: string;

  @Prop({
    type: Boolean,
  })
  readonly isLoading!: boolean;

  @Prop({
    type: String,
    default: '',
  })
  readonly id!: string;

  @Prop({
    type: String,
    default: '',
  })
  readonly name!: string;

  @Prop({
    type: String,
    default: null,
  })
  readonly iban!: string | null;

  @Prop({
    type: String,
    default: null,
  })
  readonly synesisCode!: string | null;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly isPayable!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideIban!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly ibanOptional!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideSynesisCode!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly synesisCodeRequired!: boolean;

  @Emit('submit')
  onSubmit(transactionParticipantDto: TransactionParticipantDto) {
    return transactionParticipantDto;
  }

  @Emit('delete')
  onDelete() {
    return this.id;
  }

  @Emit('update:visible')
  onCancel() {
    return false;
  }
}
